import { RootState } from '../../index';

export const selectors = {
  selectIsRegistering: (state: RootState) => state.classmarker.isRegistering,
  selectTestUrl: (state: RootState) => state.classmarker.testUrl,
  selectTestStatus: (state: RootState) => state.classmarker.testStatus,
  selectIsLoadingUrl: (state: RootState) => state.classmarker.isLoadingUrl,
  selectIsLoadingStatus: (state: RootState) => state.classmarker.isLoadingStatus,
  selectError: (state: RootState) => state.classmarker.error,
  selectCanTakeExam: (state: RootState) => {
    const status = state.classmarker.testStatus?.status;
    return status === 'in_progress' || status === 'failed' || status === 'not_registered' || !status;
  },
  selectHasPassedExam: (state: RootState) => {
    return state.classmarker.testStatus?.status === 'passed';
  },
  selectIsExamInProgress: (state: RootState) => {
    return state.classmarker.testStatus?.status === 'in_progress';
  },
  selectHasFailedExam: (state: RootState) => {
    return state.classmarker.testStatus?.status === 'failed';
  },
  selectHasLoadedTestStatus: (state: RootState) => {
    return state.classmarker.testStatus !== null && !state.classmarker.isLoadingStatus;
  },
  selectExamButtonText: (state: RootState) => {
    const status = state.classmarker.testStatus?.status;
    const activeCourse = state.courses.activeCourse;
    const courseName = activeCourse?.name || 'Certification';

    switch (status) {
      case 'failed':
        return 'Retake Exam';
      case 'in_progress':
      case 'not_registered':
      default:
        return `Take ${courseName} Exam`;
    }
  },
};
